import { PLATFORM_LABELS } from '@lib/whats-new/model';
import type { ProductUpdatePlatform } from '@lib/sanity/types';

/** Takes its text colour from the meta row, so it sits on the beta panel too. */
export const PlatformTag = ({
  platform
}: {
  platform: ProductUpdatePlatform | null;
}) => {
  const label = platform ? PLATFORM_LABELS[platform] : undefined;
  return label ? (
    <span className="inline-flex items-center rounded-full border border-[#c3ced8] px-2 font-body text-xs font-semibold leading-5">
      {label}
    </span>
  ) : null;
};
